<template>
	<div class="o-page-login" data-component="login"
        :data-component-name="$options.name"
	>
		<div class="o-row">
			<div class="o-col -login-welcome">
				<div class="o-page-login__content">
					<div class="o-page-login__header">
						<SvgIcon name="logo" class="o-page-login__logo" />
					</div>
					<!-- <div class="o-page-login__sub-header">
						Console d'affectation
					</div> -->
					<h1 class="o-page-login__title">
						Gestionnaire <br>haute performance <br>des <strong>affectations</strong>
					</h1>
					<p class="o-page-login__text">
						Optimisez et gérez efficacement les ressources humaines et matérielles nécessaires à la
						réalisation de vos projets grâce à cette application web. Connectez-vous pour accéder à votre
						gestionnaire ou <a href="mailto:info@monriff.ca?subject=Demande d'informations">contactez-nous</a> afin d’en savoir plus.
					</p>
					<a href="https://monriff.ca" target="_blank"
						class="o-button -outline -ico-right o-page-login__button">En savoir plus
						<SvgIcon name="external-link" />
					</a>
				</div>
			</div>
			<div class="o-col -login">
				<div class="o-page-connect">
					<h2 class="o-page-connect__title">Connexion</h2>
					<div class="o-page-connect__msg" v-if="sent && response" v-html="response"></div>
					<form @submit.prevent="loginUser">
						<div class="o-form__item o-page-connect__input" v-show="!usernameValid">
							<q-input class="o-page-connect__input" label="Nom d'utilisateur" v-model="form.username"
								type="text" placeholder="courriel" @keyup.enter="loginUser" autocomplete="username"
								autofocus dense borderless @input="usernameValid = null" />
						</div>
						<div class="o-form__item o-page-connect__input" v-show="usernameValid">
							<q-input ref="password" id="password" label="Mot de passe" v-model="form.password"
								type="password" @keyup.enter="loginUser" autocomplete="current-password" dense
								borderless />
						</div>
					</form>
					<div class="o-page-connect__submit">
						<div class="o-page-connect__forgotpw">
							<div v-if="usernameValid == false" style="color:red; font-weight: 600">Compte introuvable!
							</div>
							<!--<router-link :to="{ name: 'forgot' }" v-if="usernameValid">Mot de passe oublié?</router-link>-->
							<a href="" v-if="usernameValid" @click.stop.prevent="resetPassword()">Mot de passe
								oublié?</a>
						</div>
						<div class="o-page-connect__button" v-if="!usernameValid">
							<button class="o-button -ico-right" :loading="loading" @click="validateUser()"
								color="primary" :disabled="$apollo.loading">Continuer
								<SvgIcon name="arrow-right" />
							</button>
						</div>
						<div class="o-page-connect__button" v-if="usernameValid">
							<button class="o-button -ico-right" :loading="loading" @click="loginUser" color="primary"
								:disabled="$apollo.loading">Connexion
								<SvgIcon name="arrow-right" />
							</button>
						</div>
					</div>
					<!-- <div class="o-page-connect__createaccount">
						Vous n'avez pas de compte? <router-link :to="{ name: 'register' }">S'enregistrer</router-link>
					</div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import { LOGIN_USER } from '@/graphql/auth/mutations'
import { ISVALIDUSER } from '@/graphql/user/queries'
import { REQUESTPASSWORDRESET } from '@/graphql/user/mutations'

export default {
	props: {
		email: {
			type: String,
			default: null
		},
	},
	data() {
		return {
			appName: process.env.VUE_APP_NAME || 'worky.',
			loading: false,
			usernameValid: null,
			response: null,
			sent: false,
			form: {
				username: null,
				password: null
			}
		}
	},
	async created() {
		// await this.$store.dispatch('auth/logout')

	},
	mounted() {
		if (this.email) {
			this.form.username = this.email
			this.$refs.password.focus();
		}
	},
	methods: {
		validateUser() {
			this.$apollo.query({
				query: ISVALIDUSER,
				fetchPolicy: 'network-only',
				variables: {
					email: this.form.username
				},
			}).then((data) => {
				this.usernameValid = !!data.data.isValidUser;
				if (this.usernameValid) {
					this.$nextTick(function () {
						this.$refs.password.focus();
					}.bind(this))
				}
			}).catch(e => {
				console.log(e.message)
				if (e.message) this.$q.notify({ type: 'negative', message: "Accès refusé", caption: e.message });
			})
		},
		...mapActions({ 'setLogged': 'auth/setLogged', 'setMyProfile': 'auth/setMyProfile' }),
		loginUser() {

			if (!this.usernameValid) {
				this.validateUser();
				return;
			}
			this.$apollo.mutate({
				mutation: LOGIN_USER,
				variables: { ...this.form },
			}).then((data) => {
				this.setLogged(data.data.login)
					.then(() => {
						if (data.data.login.user.must_change_password) {
							this.$router.push('changepassword')
						} else {
							this.setMyProfile().then(() => {
								this.$router.push('index')
							})
						}
					})
			}).catch(e => {
				console.log(e.message)
				if (e.message) this.$q.notify({ type: 'negative', message: "Accès refusé", caption: e.message });
			})
		},
		async resetPassword() {
			this.$apollo.mutate({
				mutation: REQUESTPASSWORDRESET,
				variables: {
					email: this.form.username,
				},
			}).then(() => {
				this.sent = true;
				this.response = "Un lien de réinitialisation a été envoyé par courriel.<br><br><a href='/login'>Cliquez ici</a> pour revenir à l'écran de connexion."
			}).catch(e => {
				if (e.message) this.$q.notify({ type: 'negative', message: e.message, caption: '' });
			})

		},

	}
}
</script>

<style lang="scss">
@import "@/scss/views/Login.scss";
</style>
